import { setFcmToken, setUserData } from "../redux/slices/authSlice";

// Lazy getter to avoid circular import during store initialization
const getStore = () => {
  try {
    // require at call time to break circular dependency
    // eslint-disable-next-line global-require
    const mod = require("../redux/store");
    return mod?.store;
  } catch (_) {
    return null;
  }
};

const setTokenData = (userData) => {
  const store = getStore();
  store?.dispatch?.(setUserData(userData))
};

const setToken = (appToken) => {
  const store = getStore();
  const oldUserData = store?.getState?.()?.authReducer?.tokenData;
  store?.dispatch?.(setUserData({ ...(oldUserData || {}), token: appToken }));
};

const getTokenData = () => {
  const store = getStore();
  const token = store?.getState?.()?.authReducer?.tokenData?.token;
  console.log('bearer token----====>>>>', token);
  return token;
};
const getRefreshToken = () => {
  const store = getStore();
  return store?.getState?.()?.authReducer?.tokenData?.refreshToken;
};
const getUserData = () => {
  const store = getStore();
  return store?.getState?.()?.authReducer?.tokenData;
};

const setFcm = (fcm) => {
  const store = getStore();
  store?.dispatch?.(setFcmToken(fcm))
}

const getFcmToken = () => {
  const store = getStore();
  return store?.getState?.()?.authReducer?.fcmToken;
};

export { setTokenData, getTokenData, getRefreshToken, getUserData, setToken, setFcm, getFcmToken };
